<template>
  <component :is="iconComponent" class="m-icon" />
</template>

<script>
import { ICONS } from '@/assets/icons/icon-map';

export default {
  name: "m-icon",
  props: {
    name: String
  },
  computed: {
    iconComponent() {
      return ICONS[this.name] || null;
    }
  }
};
</script>